import * as types from './types';

export const setSummaryLoading = (isLoading = false) => ({
  type: types.APPLICATION_SET_SUMMARY_LOADING,
  isLoading
});

export const setRatingLoading = (isLoading = false) => ({
  type: types.APPLICATION_SET_RATING_LOADING,
  isLoading
});

export const setUpdateRatingLoading = (isLoading = false) => ({
  type: types.APPLICATION_SET_UPDATE_RATING_LOADING,
  isLoading
});

export const setDeleteRatingLoading = (isLoading = false) => ({
  type: types.APPLICATION_SET_DELETE_RATING_LOADING,
  isLoading
});

export const setSchoolUserRatingsLoading = (isLoading = false) => ({
  type: types.APPLICATION_SET_SCHOOL_USER_RATINGS_LOADING,
  isLoading
});

export const getApplicationSummary = (schoolId, vacancyId, applicationId) => ({
  type: types.APPLICATION_GET_SUMMARY,
  schoolId,
  vacancyId,
  applicationId
});

export const setApplicationSummary = (applicationSummary) => ({
  type: types.APPLICATION_SET_SUMMARY,
  applicationSummary
});

export const resetApplicationSummary = () => ({
  type: types.APPLICATION_RESET_SUMMARY
});

export const getApplicationRating = (schoolId, vacancyId, applicationId) => ({
  type: types.APPLICATION_GET_RATING,
  schoolId,
  vacancyId,
  applicationId
});

export const getApplicationSchoolUserRatings = (schoolId, vacancyId, applicationId) => ({
  type: types.APPLICATION_GET_SCHOOL_USER_RATINGS,
  schoolId,
  vacancyId,
  applicationId
});

export const setApplicationRating = (applicationRating) => ({
  type: types.APPLICATION_SET_RATING,
  applicationRating
});

export const setApplicationSchoolUserRatings = (applicationSchoolUserRatings) => ({
  type: types.APPLICATION_SET_SCHOOL_USER_RATINGS,
  applicationSchoolUserRatings
});

export const resetApplicationRatings = () => ({
  type: types.APPLICATION_RESET_RATINGS
});

export const updateApplicationCurrentSchoolUserRating = (schoolId, vacancyId, applicationId, rate) => ({
  type: types.APPLICATION_UPDATE_CURRENT_SCHOOL_USER_RATING,
  schoolId,
  vacancyId,
  applicationId,
  rate
});

export const deleteApplicationCurrentSchoolUserRating = (schoolId, vacancyId, applicationId) => ({
  type: types.APPLICATION_DELETE_CURRENT_SCHOOL_USER_RATING,
  schoolId,
  vacancyId,
  applicationId
});

export const setSummaryError = (error) => ({
  type: types.APPLICATION_SET_SUMMARY_ERROR,
  error
});

export const getApplicationCommentList = (schoolId, vacancyId, applicationId) => ({
  type: types.APPLICATION_GET_COMMENT_LIST,
  schoolId,
  vacancyId,
  applicationId
});

export const setApplicationCommentList = (comments) => ({
  type: types.APPLICATION_SET_COMMENT_LIST,
  comments
});

export const createApplicationComment = (schoolId, vacancyId, applicationId, parentCommentId, text, important) => ({
  type: types.APPLICATION_CREATE_COMMENT,
  schoolId, vacancyId, applicationId, 
  parentCommentId,
  text,
  important
});

export const updateApplicationComment = (schoolId, vacancyId, applicationId, commentId, text, important) => ({
  type: types.APPLICATION_UPDATE_COMMENT,
  schoolId, vacancyId, applicationId, 
  commentId,
  text,
  important
});

export const deleteApplicationComment = (schoolId, vacancyId, applicationId, commentId) => ({
  type: types.APPLICATION_DELETE_COMMENT,
  schoolId, 
  vacancyId, 
  applicationId, 
  commentId
});

export const setApplicationCommentUpdating = (isLoading = false) => ({
  type: types.APPLICATION_SET_COMMENT_UPDATING,
  isLoading
});

export const setApplicationCommentCreating = (isLoading = false) => ({
  type: types.APPLICATION_SET_COMMENT_CREATING,
  isLoading
});

export const setApplicationCommentDeleting = (isLoading = false) => ({
  type: types.APPLICATION_SET_COMMENT_DELETING,
  isLoading
});

export const setApplicationCommentListLoading = (isLoading = false) => ({
  type: types.APPLICATION_SET_COMMENT_LIST_LOADING,
  isLoading
});

export const getApplicationCoverLetter = (schoolId, vacancyId, applicationId) => ({
  type: types.APPLICATION_GET_COVER_LETTER,
  schoolId, 
  vacancyId, 
  applicationId
});

export const setApplicationCoverLetter = (applicationCoverLetter) => ({
  type: types.APPLICATION_SET_COVER_LETTER,
  applicationCoverLetter
});

export const setApplicationCoverLetterLoading = (isLoading = false) => ({
  type: types.APPLICATION_SET_COVER_LETTER_LOADING,
  isLoading
});

export const resetApplicationCoverLetter = () => ({
  type: types.APPLICATION_RESET_COVER_LETTER
});

export const getApplicationSupplementaryQuestions = (schoolId, vacancyId, applicationId) => ({
  type: types.APPLICATION_GET_SUPPLEMENTARY_QUESTIONS,
  schoolId, 
  vacancyId, 
  applicationId
});

export const setApplicationSupplementaryQuestions = (applicationSupplementaryQuestions) => ({
  type: types.APPLICATION_SET_SUPPLEMENTARY_QUESTIONS,
  applicationSupplementaryQuestions
});

export const setApplicationSupplementaryQuestionsLoading = (isLoading = false) => ({
  type: types.APPLICATION_SET_SUPPLEMENTARY_QUESTIONS_LOADING,
  isLoading
});

export const resetApplicationSupplementaryQuestions = () => ({
  type: types.APPLICATION_RESET_SUPPLEMENTARY_QUESTIONS
});

export const reviewVacancyApplicationForSchoolUser = (schoolId, vacancyId, applicationId) => ({
  type: types.APPLICATION_REVIEW_VACANCY_APPLICATION_FOR_SCHOOL_USER,
  schoolId,
  vacancyId,
  applicationId
});

export const updateApplicationIntermediateSubstatus = (schoolId, vacancyId, applicationId, substatus) => ({
  type: types.APPLICATION_UPDATE_INTERMEDIATE_SUBSTATUS,
  schoolId,
  vacancyId,
  applicationId,
  substatus
});

export const cancelApplicationIntermediateSubstatus = (schoolId, vacancyId, applicationId, substatus) => ({
  type: types.APPLICATION_CANCEL_INTERMEDIATE_SUBSTATUS,
  schoolId,
  vacancyId,
  applicationId,
  substatus
});

export const setApplicationIntermediateSubstatusUpdating = (isLoading) => ({
  type: types.APPLICATION_SET_INTERMEDIATE_SUBSTATUS_UPDATING,
  isLoading
});

export const updateApplicationFinalDecision = (schoolId, vacancyId, applicationId, template, substatus) => ({
  type: types.APPLICATION_UPDATE_FINAL_DECISION,
  schoolId,
  vacancyId,
  applicationId,
  template,
  substatus
});

export const setApplicationFinalDecisionUpdating = (isLoading) => ({
  type: types.APPLICATION_SET_FINAL_DECISION_UPDATING,
  isLoading
});

export const setApplicationBatchIntermediateSubstatusUpdating = (isLoading) => ({
  type: types.APPLICATION_SET_BATCH_INTERMEDIATE_SUBSTATUS_UPDATING,
  isLoading
});

export const updateApplicationBatchIntermediateSubstatus = (schoolId, vacancyId, applicationIds, substatus) => ({
  type: types.APPLICATION_UPDATE_BATCH_INTERMEDIATE_SUBSTATUS,
  schoolId,
  vacancyId,
  applicationIds,
  substatus
});

export const setApplicationBatchIntermediateSubstatusOperationData = (data) => ({
  type: types.APPLICATION_SET_BATCH_INTERMEDIATE_SUBSTATUS_OPERATION_DATA,
  data
});

export const resetApplicationBatchIntermediateSubstatusOperationData = () => ({
  type: types.APPLICATION_RESET_BATCH_INTERMEDIATE_SUBSTATUS_OPERATION_DATA
});

export const setApplicationBatchFinalDecisionUpdating = (isLoading) => ({
  type: types.APPLICATION_SET_BATCH_FINAL_DECISION_UPDATING,
  isLoading
});

export const updateApplicationBatchFinalDecision = (schoolId, vacancyId, applicationIds, substatus) => ({
  type: types.APPLICATION_UPDATE_BATCH_FINAL_DECISION,
  schoolId,
  vacancyId,
  applicationIds,
  substatus
});

export const setApplicationBatchFinalDecisionOperationData = (data) => ({
  type: types.APPLICATION_SET_BATCH_FINAL_DECISION_OPERATION_DATA,
  data
});

export const resetApplicationBatchFinalDecisionOperationData = () => ({
  type: types.APPLICATION_RESET_BATCH_FINAL_DECISION_OPERATION_DATA
});

export const setApplicationFinalDecisionCanceling = (isLoading) => ({
  type: types.APPLICATION_SET_FINAL_DECISION_CANCELING,
  isLoading
});

export const cancelApplicationFinalDecision = (schoolId, vacancyId, applicationId, emailTemplate) => ({
  type: types.APPLICATION_CANCEL_FINAL_DECISION,
  schoolId,
  vacancyId,
  applicationId,
  emailTemplate
});

export const getApplicationDocuments = (schoolId, vacancyId, applicationId) => ({
  type: types.APPLICATION_GET_DOCUMENTS,
  schoolId, 
  vacancyId, 
  applicationId
});

export const setApplicationDocuments = (applicationDocuments) => ({
  type: types.APPLICATION_SET_DOCUMENTS,
  applicationDocuments
});

export const setApplicationDocumentsLoading = (isLoading = false) => ({
  type: types.APPLICATION_SET_DOCUMENTS_LOADING,
  isLoading
});

export const resetApplicationDocuments = () => ({
  type: types.APPLICATION_RESET_DOCUMENTS
});


// WEBPACK FOOTER //
// ./src/actions/applications/index.js